import React from "react";
import {
    GiAirtightHatch,
    GiAlienStare,
    GiAllSeeingEye,
    GiAmberMosquito,
    GiAnchor,
    GiArtificialIntelligence,
    GiAstronautHelmet,
    GiBeerBottle,
    GiBrassKnuckles,
    GiCampfire,
    GiCandleSkull,
    GiCaravan,
    GiCardRandom,
    GiCaveEntrance,
    GiCaveman,
    GiCctvCamera,
    GiCircuitry,
    GiCoinsPile,
    GiCompass,
    GiCrossedSwords,
    GiCrystalBall,
    GiCrystalBars,
    GiCyberEye,
    GiDarkSquad,
    GiDinosaurRex,
    GiDominoMask,
    GiFedora,
    GiGasMask,
    GiHolosphere,
    GiHood,
    GiHoodedFigure,
    GiHornedHelm,
    GiKatana,
    GiKnapsack,
    GiKrakenTentacle,
    GiMartini,
    GiMechanicalArm,
    GiMolotov,
    GiMoneyStack,
    GiNinjaMask,
    GiOilDrum,
    GiOni,
    GiOpenTreasureChest,
    GiPirateCaptain,
    GiPirateFlag,
    GiPirateHat,
    GiRadioactive,
    GiRayGun,
    GiRoundTable,
    GiSaberAndPistol,
    GiSamuraiHelmet,
    GiScrollUnfurled,
    GiShintoShrineMirror,
    GiSilverBullet,
    GiSkeletonKey,
    GiSkullInJar,
    GiSpaceSuit,
    GiSpellBook,
    GiSpiderBot,
    GiSpikedDragonHead,
    GiSpookyHouse,
    GiStakeHammer,
    GiStoneSpear,
    GiStoneTablet,
    GiStoneThrone,
    GiTavernSign,
    GiTeapotLeaves,
    GiThirdEye,
    GiTotemMask,
    GiTreasureMap,
    GiTribalMask,
    GiTwoCoins,
    GiVampireDracula,
    GiVerticalBanner,
    GiVrHeadset,
    GiVulture,
    GiWerewolf,
    GiWizardFace,
} from "../icons/startupGameIcons";
import {useLightMode} from "../context/ThemeContext";
import cantinaPng from "../assets/icons/scifi-cantina.webp";
import brandLogo from "../assets/ddroplogo.webp";
import brandLogoScifi from "../assets/ddroplogo-scifi.webp";
import tearLogo from "../assets/dragonDropTear.webp";
import tearLogoScifi from "../assets/dragonDropTear-scifi.webp";
import brandLogoHorror from "../assets/ddroplogo-horror.webp";
import tearLogoHorror from "../assets/dragonDropTear-horror.webp";
import brandLogoPostapoc from "../assets/ddroplogo-postapoc.webp";
import tearLogoPostapoc from "../assets/dragonDropTear-postapoc.webp";
import brandLogoPirate from "../assets/ddroplogo-pirate.webp";
import tearLogoPirate from "../assets/dragonDropTear-pirate.webp";
import brandLogoUrban from "../assets/ddroplogo-urban.webp";
import tearLogoUrban from "../assets/dragonDropTear-urban.webp";
import brandLogoJapan from "../assets/ddroplogo-japan.webp";
import tearLogoJapan from "../assets/dragonDropTear-japan.webp";
import brandLogoCyberpunk from "../assets/ddroplogo-cyberpunk.webp";
import tearLogoCyberpunk from "../assets/dragonDropTear-cyberpunk.webp";
import brandLogoPrimal from "../assets/ddroplogo-primal.webp";
import tearLogoPrimal from "../assets/dragonDropTear-primal.webp";

// The app's navigation icons in each genre (see utilities/themeColors for the palette).
// Only the chrome is themed: the destinations a user moves between. Content icons - monster
// types, conditions, dice - mean the same thing in any genre and are left alone.

// White-on-transparent PNG used as a mask, so it takes currentColor like the SVG icons.
const CantinaIcon = ({size = '1em', style}) => {
    const dim = typeof size === 'number' ? size + 'px' : size;
    return (
        <span role="img" aria-hidden="true"
              style={{display: 'inline-block', width: dim, height: dim, flexShrink: 0,
                  backgroundColor: 'currentColor',
                  WebkitMask: `url(${cantinaPng}) center / contain no-repeat`,
                  mask: `url(${cantinaPng}) center / contain no-repeat`,
                  ...style}}/>
    );
};

export const NAV_ICONS = {
    tavern:     {fantasy: GiTavernSign,       scifi: CantinaIcon,              horror: GiSpookyHouse,  postapoc: GiAirtightHatch, pirate: GiAnchor,            urban: GiMartini, japan: GiTeapotLeaves, cyberpunk: GiBeerBottle, primal: GiCaveEntrance},
    tabletop:   {fantasy: GiRoundTable,       scifi: GiHolosphere,             horror: GiCandleSkull,  postapoc: GiCampfire,    pirate: GiTreasureMap,       urban: GiCardRandom, japan: GiScrollUnfurled, cyberpunk: GiVrHeadset, primal: GiStoneTablet},
    gameMaster: {fantasy: GiWizardFace,       scifi: GiAstronautHelmet,        horror: GiHoodedFigure, postapoc: GiGasMask,     pirate: GiPirateCaptain,     urban: GiAllSeeingEye, japan: GiSamuraiHelmet, cyberpunk: GiCctvCamera, primal: GiStoneThrone},
    party:      {fantasy: GiCrossedSwords,    scifi: GiSpaceSuit,              horror: GiDarkSquad,    postapoc: GiCaravan,     pirate: GiPirateFlag,        urban: GiDominoMask, japan: GiVerticalBanner, cyberpunk: GiBrassKnuckles, primal: GiCaveman},
    equipment:  {fantasy: GiKnapsack,         scifi: GiRayGun,                 horror: GiStakeHammer,  postapoc: GiMolotov,     pirate: GiSaberAndPistol,    urban: GiSilverBullet, japan: GiKatana, cyberpunk: GiMechanicalArm, primal: GiStoneSpear},
    bestiary:   {fantasy: GiSpikedDragonHead, scifi: GiAlienStare,             horror: GiWerewolf,     postapoc: GiVulture,     pirate: GiKrakenTentacle,    urban: GiVampireDracula, japan: GiOni, cyberpunk: GiSpiderBot, primal: GiDinosaurRex},
    hoard:      {fantasy: GiCoinsPile,        scifi: GiCrystalBars,            horror: GiSkullInJar,   postapoc: GiOilDrum,     pirate: GiOpenTreasureChest, urban: GiSkeletonKey, japan: GiTwoCoins, cyberpunk: GiMoneyStack, primal: GiAmberMosquito},
    sage:       {fantasy: GiSpellBook,        scifi: GiArtificialIntelligence, horror: GiCrystalBall,  postapoc: GiRadioactive, pirate: GiCompass,           urban: GiThirdEye, japan: GiShintoShrineMirror, cyberpunk: GiCircuitry, primal: GiTribalMask},
    // Not a destination: the username field on the login-type pages.
    username:   {fantasy: GiHornedHelm,       scifi: GiAstronautHelmet,        horror: GiHood,         postapoc: GiGasMask,     pirate: GiPirateHat,         urban: GiFedora, japan: GiNinjaMask, cyberpunk: GiCyberEye, primal: GiTotemMask},
};

/** The icon component for a nav destination in a given genre - for render trees outside the
 *  ThemeContext provider (e.g. drei <Html>, which mounts its own React root). */
export const genreIconFor = (name, genre) => NAV_ICONS[name]?.[genre] ?? NAV_ICONS[name]?.fantasy ?? null;

/** A navigation icon in the current genre. Takes the same size/style props as react-icons. */
export function GenreIcon({name, ...props}) {
    const {genre} = useLightMode();
    const Icon = genreIconFor(name, genre);
    return Icon ? <Icon {...props}/> : null;
}

// A component bound to one name, for lists that hold an `Icon` component per entry.
const bound = {};
export function navIcon(name) {
    if (!bound[name]) {
        const Bound = (props) => <GenreIcon name={name} {...props}/>;
        Bound.displayName = `NavIcon(${name})`;
        bound[name] = Bound;
    }
    return bound[name];
}

// Nav destination names that change with the genre, alongside the icons. Names not listed
// here read the same in every genre.
export const NAV_LABELS = {
    tavern: {fantasy: 'Tavern', scifi: 'Cantina', horror: 'Manor',     postapoc: 'Outpost', pirate: 'Port',    urban: 'Speakeasy', japan: 'Teahouse', cyberpunk: 'Bar',    primal: 'Cave'},
    party:  {fantasy: 'Party',  scifi: 'Crew',    horror: 'Coven',     postapoc: 'Clan',    pirate: 'Crew',    urban: 'Cabal',     japan: 'Clan',     cyberpunk: 'Gang',   primal: 'Tribe'},
    hoard:  {fantasy: 'Hoard',  scifi: 'Cache',   horror: 'Reliquary', postapoc: 'Stash',   pirate: 'Plunder', urban: 'Vault',     japan: 'Treasury', cyberpunk: 'Payday', primal: 'Trove'},
};

export const genreLabelFor = (name, genre) => NAV_LABELS[name]?.[genre] ?? NAV_LABELS[name]?.fantasy ?? null;

/** A nav destination's name in the current genre, e.g. useNavLabel('tavern') -> 'Cantina'. */
export function useNavLabel(name) {
    const {genre} = useLightMode();
    return genreLabelFor(name, genre);
}

// Words used in running text that change with the genre: a Fantasy party is a Sci-Fi or Pirate
// crew, a Horror coven, a Post-Apocalyptic or Samurai clan, an Urban Fantasy cabal and a Primal
// tribe, and the Hoard (the community content catalog) is the Cache / the Reliquary / the Stash /
// the Plunder / the Vault / the Treasury / the Payday / the Trove. Only the wording changes - routes,
// API fields and data-help ids keep the fantasy names. "Treasure hoard" the D&D rules term is
// not this and stays put.
const TERMS = {
    fantasy: {party: 'party', parties: 'parties', hoard: 'hoard'},
    scifi:   {party: 'crew',  parties: 'crews',   hoard: 'cache'},
    horror:  {party: 'coven', parties: 'covens',  hoard: 'reliquary'},
    postapoc: {party: 'clan', parties: 'clans',   hoard: 'stash'},
    pirate:  {party: 'crew',  parties: 'crews',   hoard: 'plunder'},
    urban:   {party: 'cabal', parties: 'cabals',  hoard: 'vault'},
    japan:   {party: 'clan',  parties: 'clans',   hoard: 'treasury'},
    cyberpunk: {party: 'gang', parties: 'gangs',  hoard: 'payday'},
    primal:  {party: 'tribe', parties: 'tribes',  hoard: 'trove'},
};
const cap = s => s.charAt(0).toUpperCase() + s.slice(1);

/** Every form of each of the genre's terms: party / Party / PARTY, hoard / Hoard / HOARD, ... */
export function genreTerms(genre) {
    const t = TERMS[genre] ?? TERMS.fantasy;
    const out = {};
    for (const [key, word] of Object.entries(t)) {
        out[key] = word;
        out[cap(key)] = cap(word);
        out[key.toUpperCase()] = word.toUpperCase();
    }
    return out;
}

// What the GM is called on the tabletop - its GM view toggle and the players' "paused" screen -
// matching each genre's Game Master icon. Fantasy keeps the familiar "GM".
const GM_TITLES = {
    fantasy:   {title: 'GM',        view: 'GM View'},
    scifi:     {title: 'Captain',   view: "Captain's View"},
    horror:    {title: 'Keeper',    view: "Keeper's View"},
    postapoc:  {title: 'Warlord',   view: "Warlord's View"},
    pirate:    {title: 'Captain',   view: "Captain's View"},
    urban:     {title: 'Watcher',   view: "Watcher's View"},
    japan:     {title: 'Shogun',    view: "Shogun's View"},
    cyberpunk: {title: 'Fixer',     view: "Fixer's View"},
    primal:    {title: 'Chieftain', view: "Chieftain's View"},
};

/** The current genre's GM title and GM-view label, e.g. {title: 'Captain', view: "Captain's View"}. */
export function useGmTitle() {
    const {genre} = useLightMode();
    return GM_TITLES[genre] ?? GM_TITLES.fantasy;
}

/** genreTerms for the current genre, e.g. `${terms.Party} Name` -> 'Crew Name'. */
export function useGenreTerms() {
    const {genre} = useLightMode();
    return genreTerms(genre);
}

// The DropWyrm logos in each genre. The -scifi files are generated from the originals
// (ddroplogo: teal recolor, now framed as a ringed planet; dragonDropTear: purple-to-teal hue
// rotation), and the -horror, -postapoc, -pirate, -urban, -japan, -cyberpunk and -primal ones by
// scripts/blender/build_genre_images.py, which also frames each genre's round logo (all but
// Fantasy's and Cyberpunk's), so regenerate them if the original logo art changes.
const BRAND_LOGOS = {
    // round logo: header, login pages
    disc: {fantasy: brandLogo, scifi: brandLogoScifi, horror: brandLogoHorror, postapoc: brandLogoPostapoc, pirate: brandLogoPirate, urban: brandLogoUrban,
           japan: brandLogoJapan, cyberpunk: brandLogoCyberpunk, primal: brandLogoPrimal},
    // glowing teardrop: tabletop
    tear: {fantasy: tearLogo,  scifi: tearLogoScifi,  horror: tearLogoHorror,  postapoc: tearLogoPostapoc,  pirate: tearLogoPirate,  urban: tearLogoUrban,
           japan: tearLogoJapan, cyberpunk: tearLogoCyberpunk, primal: tearLogoPrimal},
};

/** A logo image URL for the current genre, for an <img src>. */
export function useBrandLogo(variant = 'disc') {
    const {genre} = useLightMode();
    const set = BRAND_LOGOS[variant] ?? BRAND_LOGOS.disc;
    return set[genre] ?? set.fantasy;
}

// The Tavern / Cantina backdrop, behind both the 3D scene and the 2D dashboard (public/images).
const TAVERN_BACKGROUNDS = {
    fantasy: '/images/tavern_background.webp',
    scifi:   '/images/cantina_background.webp',
    horror:  '/images/manor_background.webp',
    postapoc: '/images/outpost_background.webp',
    pirate:  '/images/port_background.webp',
    urban:   '/images/speakeasy_background.webp',
    japan:   '/images/teahouse_background.webp',
    cyberpunk: '/images/bar_background.webp',
    primal:  '/images/cave_background.webp',
};

const TAVERN_BG_BLUR = 3;   // px

/** Style for the Tavern page's backdrop layer in the current genre: the image, blurred and
 *  dimmed so it reads as atmosphere behind the dashboard or the 3D scene.
 *
 *  Held still. It used to pulse (0.3-0.6 behind the dashboard, 0.45-0.85 behind the scene),
 *  which was found too busy; each view now sits at the low end of its old pulse. */
export function useTavernBackgroundStyle(opacity = 0.3) {
    const {genre} = useLightMode();
    const url = TAVERN_BACKGROUNDS[genre] ?? TAVERN_BACKGROUNDS.fantasy;
    return {
        // Overscan: a blur fades the image's own edges to transparent, which would show as a
        // dark frame. The Tavern's main column clips the overflow.
        position: 'absolute', inset: -TAVERN_BG_BLUR * 3,
        backgroundImage: `url(${url})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        filter: `blur(${TAVERN_BG_BLUR}px)`,
        opacity,
    };
}

/** An icon component that renders `Fantasy`, or the current genre's entry in `byGenre`
 *  ({scifi, horror, postapoc, pirate, urban, japan, cyberpunk, primal}), for tables that hold one `Icon` per entry (e.g. SageCardView's
 *  KIND_META). Built once per set, at module load, so the component identity is stable across
 *  renders. A genre without an entry falls back to Fantasy. */
export function genreAwareIcon(Fantasy, byGenre = {}) {
    const Icon = (props) => {
        const {genre} = useLightMode();
        const Chosen = byGenre[genre] ?? Fantasy;
        return <Chosen {...props}/>;
    };
    Icon.displayName = `GenreAware(${Fantasy.displayName || Fantasy.name})`;
    return Icon;
}
